 import { styled } from "@mui/material/styles";

 const StyledEditProfile = styled("div")(
  ({ theme }) => `
  .edit-profile-container {
    margin: 20px 30% 0px;
    @media screen and (max-width: 600px) {
    margin: 20px 5% 0px;
  }
  }
  .back-btn-edit-profile {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .order-history-title {
    font-family: Lexend;
    font-weight: 400;
    font-size: 24px;
    line-height: 100%;
    color: ${theme.palette.primary.secondary};
  }
  .user-profile-img {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    margin: 30px auto 0px;
    position: relative;
  }
  .user-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
  .user-profile-img-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .edit-profile-form-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .custom-radio-group {
    display: flex;
    gap: 12px;
  }
  .custom-radio {
    font-family: Lexend;
    font-weight: 400;
    font-size: 14px;
    line-height: 17.5px;
    width: 100%;
    min-height: 38px !important;
    max-height: 38px !important;
    border: 1px solid #ccc;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover {
      border: 1px solid ${theme.palette.customColor.secondaryThird};
    }
    &.selected {
      background-color: ${theme.palette.secondary.main};
      color: ${theme.palette.customColor.white};
      border-color: ${theme.palette.secondary.main};
    }
  }
  .subtitle3 {
    font-family: Lexend;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: ${theme.palette.primary.main};
    margin-bottom: 5px;
  }
.switch-container {
  display: flex;
  align-items: center;
  margin-left: 0;
  margin-bottom: 4px;
}

.custom-switch-label {
  display: flex;
  align-items: center;
}

.custom-switch {
  position: relative;
  padding: 10px;
  width: 40px;
  height: 10px;
  background-color: grey;
  border-radius: 30px !important;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-width: 1px !important; 
  border-color: black !important; 
}

.custom-switch::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: ${theme.palette.customColor.white};
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.custom-switch.active {
  background-color: ${theme.palette.secondary.main};
}

.custom-switch.active::before {
  transform: translateX(20px);
}

.custom-switch-text {
  font-family: 'Lexend', sans-serif;
  font-weight: 400;
  font-size: 12px;
  margin-left: 10px;
  line-height: 15px;
  color: ${theme.palette.primary.main};
}
.MuiSwitch-thumb {
  display: none;
}
.mobile-input-group {
  display: flex;
  align-items: center;
  gap: 16px;
}

.country-code-autocomplete {
  flex: 0 0 80px;
}

.mobile-number-input {
  flex: 1;
  height: 77px;
}
.country-flag {
  width: 20px;
  height: 14px;
  margin-right: 8px;
}
.country-code-input .MuiOutlinedInput-input {
  color: black;
}
.country-code-input {
  height: 77px;
}  

.custom-dropdown-icon {
  width: 20px;
  height: 20px;
  margin-right: -25px;
}

.custom-country-dropdown-icon {
  width: 20px;
  height: 20px;
}
.MuiInputBase-root {
  height: 40px !important;
}
.submit-btn {
  width: 100%;
  margin: -20px 0px 40px;
}
.custom-save-button {
  background-color: ${theme.palette.primary.main} !important;
  color: ${theme.palette.customColor.white} !important;
  border-radius: 0px !important;
  height: 40px !important;
  font-family: Lexend;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  text-transform: none;
  width: 100%;
}
    .avatar-container {
  position: relative;
  display: inline-block;
  margin-top: 20px;
}
    
    .avatar-container .MuiAvatar-img {
    object-fit-cover;
    cursor: pointer;
    height: 68%;
    width: 70%;
    border-radius: 100%;
  }
.avatar-container .Profile-Picture{
  position: relative;
  width: 158px;
  height:160px;
  cursor: pointer;
  object-fit: cover;
  margin: 0px auto;
}

  .popup-menu {
    position: absolute;
    width: 240px; /* Adjust width */
    background-color: ${theme.palette.customColor.white};
    box-shadow: 0px 4px 6px ${theme.palette.customColor.backdrop};
    display: none;
    z-index: 10;
    top: 0;
    left: 60%; 
}
  .popup-menu .menu-item {
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.popup-menu .menu-item:hover {
  background-color: ${theme.palette.customColor.lightBeige};
}

.popup-menu .menu-item.remove {
  color: ${theme.palette.customColor.red};
}

.popup-menu .menu-icon {
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

.change-profile {
  color: rgba(5, 5, 5, 1) !important; /* Black */
}

.remove-profile {
  color: rgba(182, 2, 24, 1) !important; /* Red */
}
  .loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}


  .MuiOutlinedInput-root{
  padding-right: 34px !important;
  }
  .avatar-container .camera-icon {
  position: absolute;
  bottom: 65%;
  right: 41%;
  width: 40px;
  height: 40px;
  background-color: ${theme.palette.secondary.main} !important; 
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
  .avatar-container .camera-icon svg {
  color: ${theme.palette.customColor.white} !important;
  font-size: 22px !important;
}         
  
.input-group-2 {
  margin: -35px 0px 40px;
}
                          
    `
 );

 export default StyledEditProfile;
